// Reads the client subdomain from the browser address.
//   ethosboard.com          -> null  (main site)
//   igi.ethosboard.com      -> 'igi'
//   dev.ethosboard.com      -> null  (dev main site)
//   igi.dev.ethosboard.com  -> 'igi'
//   igi.localhost           -> 'igi' (local testing)
//   localhost               -> null

const ROOT_DOMAINS = ['dev.ethosboard.com', 'ethosboard.com', 'localhost']; // longest first
const RESERVED = ['www', 'api', 'dev', 'admin', 'app', 'mail', 'static', 'assets'];

export const getTenantSlug = () => {
  const host = window.location.hostname.toLowerCase();

  for (const root of ROOT_DOMAINS) {
    if (host.endsWith(`.${root}`)) {
      const sub = host.slice(0, -(root.length + 1));
      if (sub && !sub.includes('.') && !RESERVED.includes(sub)) return sub;
    }
  }
  return null;
};

export const isTenantDomain = () => getTenantSlug() !== null;